<header class="emptyHeaderMain"></header>
<div class="container">
  <div class="row">
    <div class="col-md-3 col-2"></div>
    <div class="col-md-6 col-8">
      <h1>Change Password</h1>
    </div>
    <div class="col-md-3 col-2"></div>
  </div>
  <div class="row">
    <div class="col-md-3 col-2"></div>
    <div class="col-md-6 col-8">
      <form [formGroup]="form">
        <div class="form-group mb-3" *ngIf="!token">
          <label class="form-label" for="oldPassword">Old Password</label>

          <input
            id="oldPassword"
            type="password"
            class="form-control"
            formControlName="oldPassword"
            required />
        </div>

        <div class="form-group mb-3">
          <label class="form-label" for="password">New Password</label>

          <input
            type="password"
            id="password"
            class="form-control"
            [ngClass]="{ 'has-error': !passwordsMatch }"
            formControlName="password"
            required />
        </div>

        <div class="form-group mb-3">
          <label class="form-label" for="repeatPassword">
            Confirm New Password
          </label>

          <input
            id="repeatPassword"
            type="password"
            class="form-control"
            [ngClass]="{ 'has-error': !passwordsMatch }"
            formControlName="repeatPassword"
            required />
        </div>

        <div
          *ngIf="showErrors || !passwordsMatch || passwordsTooShort"
          class="form-group mb-3 has-error">
          <p
            class="form-text"
            *ngIf="
              !form.controls.oldPassword.valid &&
              !form.controls.password.valid &&
              !form.controls.repeatPassword.valid
            ">
            Please enter your old and new password.
          </p>

          <p class="form-text" *ngIf="!passwordsMatch">
            <b>New Password</b>
            and
            <b>Confirm New Password</b>
            do not match.
          </p>

          <p class="form-text" *ngIf="passwordsTooShort">
            Password is too short!
          </p>

          <p *ngIf="errors" class="form-text">{{ errors }}</p>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-4 col-lg-3">
            <!--
            <oauth-buttons classes="btn-block"></oauth-buttons>
            -->
          </div>
        </div>

        <div *ngIf="successful && !token" class="success">
          Password Changed Successfully!
        </div>
        <div *ngIf="successful && token" class="success">
          Your password was updated successfully. Click on
          <a routerLink="/login">this link</a>
          to log in!
        </div>
      </form>

      <div>
        <button
          [disabled]="!valid || this.pending"
          (click)="submit()"
          class="btn btn-secondary btn-lg">
          Change Password
        </button>
      </div>
    </div>
    <div class="col-md-3 col-2"></div>
  </div>
  <hr />
</div>
